import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, Col, Spinner } from "react-bootstrap";
import _ from "lodash";
import ApiUserTransaction from "../../../../core/api/api.userTransaction";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import GlobalFormControl from "../../_Components/GlobalFormControl";

const UserTransactions = () => {
  const [listData, setListData] = useState({});
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});
  const methods = {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  };

  useEffect(() => {
    (async () => {
      try {
        const apiData = await ApiUserTransaction.getAllUserTransaction({
          pageSize: getValues("pageSize"),
          pageNumber: getValues("pageNumber"),
          globalSearch: "",
        });
        apiData.data.map((item, index) => {
          item.noRow = apiData.pageSize * (apiData.pageNumber - 1) + index + 1;
        });
        setListData(apiData);
        setValue("totalCount", apiData.totalCount);
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  const onSubmit = async (data) => {
    const apiData = await ApiUserTransaction.getAllUserTransaction({
      pageSize: data.pageSize,
      pageNumber: getValues("pageNumber"),
      globalSearch: data.globalSearch,
    });
    apiData.data.map((item, index) => {
      item.noRow = apiData.pageSize * (apiData.pageNumber - 1) + index + 1;
    });
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              تراکنش های کیف پول
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              لیست تراکنش های کیف پول شما
            </span>
          </h3>
          <div className="card-toolbar">
            {/* <Link variant="success" className="btn btn-success"
                            key={0}
                            to={{
                                pathname: "/agentAccount/0",
                                state: { newAgentAccount: true }
                            }}
                        >
                            درج حساب جدید
                        </Link> */}
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                <InputGroup className="mb-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                        onInput={onChange}
                      />
                    )}
                  />

                  <Button
                    variant="secondary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <Spinner animation="border" variant="warning" size="sm" />
                    ) : (
                      <SearchIcon />
                    )}
                  </Button>
                </InputGroup>
              </div>
              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                <DataGrid data={listData} />
              </Col>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default UserTransactions;
